var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "conformity well well-no-shadow fs-3" },
    [
      _c("h2", { staticClass: "mt-0 mb-1" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Attestation de conformité")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "mt-0" },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$l10n.__(
                  "Retrouvez dans cette page les informations concernant la conformité de votre compte SELLSY."
                )
              ) +
              "\n        "
          ),
          _c("CompassLink", {
            attrs: {
              rel: "noopener noreferrer",
              label: _vm.$t.__("common.labels.learn_more"),
              link: "https://help.sellsy.com/hc/",
              target: "_blank"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading"
            }
          ],
          staticClass: "b-1 flex-row py-4 px-3 ai-center"
        },
        [
          _c(
            "div",
            [
              _c("p", { staticClass: "m-0 semibold" }, [
                _vm._v(_vm._s(_vm.mainLabel))
              ]),
              _vm._v(" "),
              _vm.isConform
                ? [
                    _c("p", { staticClass: "m-0 gray-60" }, [
                      !_vm.isToday && !_vm.isYesterday
                        ? _c("span", [_vm._v(_vm._s(_vm.dateLabel))])
                        : _vm._e(),
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$filters.dateFormatter(
                              _vm.activatedAt,
                              "NORMAL_DATE_TIME"
                            )
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "m-0 gray-60" }, [
                      _vm._v(_vm._s(_vm.userLabel))
                    ])
                  ]
                : _c("p", { staticClass: "m-0 gray-60" }, [
                    _vm._v(_vm._s(_vm.secondaryLabel))
                  ]),
              _vm._v(" "),
              _vm.isConform && _vm.isTrial
                ? _c("p", { staticClass: "mb-0 mt-2 red semibold" }, [
                    _vm._v(_vm._s(_vm.trialLabel))
                  ])
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-item-right" },
            [
              _vm.isConform
                ? _c(
                    "el-link",
                    {
                      staticClass: "btn btn-primary",
                      class: { "btn-disabled": !_vm.pdf || _vm.isTrial },
                      attrs: {
                        type: "primary",
                        disabled: !_vm.pdf || _vm.isTrial,
                        href: _vm.gatePdf,
                        target: "_blank",
                        download: _vm.$t.__(
                          "settings.sellsymodule.invoicing.Conformity.conformity_certificate"
                        )
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.pdf
                              ? _vm.$l10n.__("Télécharger mon attestation")
                              : _vm.$l10n.__("En cours de génération")
                          ) +
                          "\n            "
                      )
                    ]
                  )
                : _c("CompassButton", {
                    attrs: {
                      label: _vm.$t.__(
                        "settings.sellsymodule.invoicing.Conformity.enable_conformity_mode"
                      ),
                      disabled: !_vm.iscreatable
                    },
                    on: {
                      click: function($event) {
                        _vm.displayForm = true
                      }
                    }
                  })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("CompassDialog", {
        staticClass: "conformity",
        attrs: {
          visible: _vm.displayForm,
          title: _vm.$t.__(
            "settings.sellsymodule.invoicing.Conformity.enable_conformity_mode_on_account"
          ),
          size: "large"
        },
        on: {
          "update:visible": function($event) {
            _vm.displayForm = $event
          },
          closed: _vm.closeModal
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "dialog__default" },
                  [
                    !_vm.isConfirm
                      ? _c(
                          "el-form",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.loading,
                                expression: "loading"
                              }
                            ]
                          },
                          [
                            _c(
                              "h3",
                              {
                                staticClass: "uppercase typographies-heading-h3"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$l10n.__("Important")) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "typographies-paragraph-medium-semibold mb-4"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$l10n.__("Conformité de votre compte")
                                    ) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "mb-3 typographies-paragraph-medium-regular"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Nous souhaitons vous proposer de rendre votre compte conforme à la législation française en vigueur. Pour cela, plusieurs paramètres seront modifiés pouvant impacter votre utilisation de SELLSY. "
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "typographies-paragraph-medium-semibold"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Les modifications de paramètres nécessaires à cette mise en conformité sont les suivants:"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.conditions, function(condition, index) {
                              return _c(
                                "el-form-item",
                                { key: index, staticClass: "b-1 p-4 mt-3" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "typographies-paragraph-medium-semibold fix-margin-p"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(condition.title) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "my-3 typographies-paragraph-medium-regular"
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(condition.content) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticClass:
                                        "typographies-paragraph-medium-semibold",
                                      model: {
                                        value: condition.accept,
                                        callback: function($$v) {
                                          _vm.$set(condition, "accept", $$v)
                                        },
                                        expression: "condition.accept"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(condition.label) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c("p", {
                              staticClass:
                                "typographies-paragraph-medium-semibold bt-4-red bb-4-red py-3 mt-6 px-4",
                              domProps: { innerHTML: _vm._s(_vm.disclaimer) }
                            }),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { staticClass: "mt-6 px-4" },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    staticClass:
                                      "typographies-paragraph-medium-semibold agree-checkbox",
                                    model: {
                                      value: _vm.acceptGlobal,
                                      callback: function($$v) {
                                        _vm.acceptGlobal = $$v
                                      },
                                      expression: "acceptGlobal"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$l10n.__(
                                            "J’ai pris connaissance des futures modifications apportées à mon compte SELLSY et du choix définitif de leur application."
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          2
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "confirm-section flex-column ai-center"
                          },
                          [
                            _c("i", {
                              staticClass: "icon-email-statut-valid success"
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "typographies-paragraph-medium-semibold fs-5 mt-4"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Votre compte est désormais conforme"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          ]
                        )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c("div", { staticClass: "dialog__footer" }, [
                  !_vm.isConfirm
                    ? _c(
                        "div",
                        [
                          _c("CompassButton", {
                            attrs: {
                              label: _vm.$t.__("common.actions.cancel"),
                              type: "secondary"
                            },
                            on: {
                              click: function($event) {
                                _vm.displayForm = false
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("CompassButton", {
                            staticClass: "ml-3",
                            attrs: {
                              label: _vm.$t.__(
                                "settings.sellsymodule.invoicing.Conformity.make_account_compliant"
                              ),
                              disabled: !_vm.allAccept
                            },
                            on: { click: _vm.confirm }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c("CompassButton", {
                            staticClass: "mt-5",
                            attrs: {
                              label: _vm.$t.__("common.actions.back_settings"),
                              type: "primary"
                            },
                            on: {
                              click: function($event) {
                                _vm.displayForm = false
                              }
                            }
                          })
                        ],
                        1
                      )
                ])
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }